// extracted by mini-css-extract-plugin
module.exports = {"link":"NavigationLink_link__KSHz2","activeLink":"NavigationLink_activeLink__oMew7","icon":"NavigationLink_icon__n7Hne","linkText":"NavigationLink_linkText__MC_b4"};